import script from "./clinic-receptionlist.vue?vue&type=script&setup=true&lang=js"
export * from "./clinic-receptionlist.vue?vue&type=script&setup=true&lang=js"

import "./clinic-receptionlist.vue?vue&type=style&index=0&id=69f55826&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69f55826"]])

export default __exports__